module.exports = __webpack_public_path__ + "img/7.06b70b7d.png";